/**
 * Truncates text with dots. If truncates file name, it will preserve file extension after dots.
 * @param {string} text - The text to truncate
 * @param {number} [maxLength=25] - Maximum length of the result including the preserved part. Default is 25
 * @returns {string} Truncated text with preserved part after last dot
 * @example
 * truncate('very.long.text.here', 15) // => 'very.long...here'
 * truncate('short.text') // => 'short.text'
 * truncate('no_dots_here', 5) // => 'no...'
 * truncate('ends.with.dot.', 10) // => 'ends.w...'
 * truncate('just.', 10) // => 'just...'
 */
export const truncate = (text, maxLength = 25) => {
    if (!text || text.length <= maxLength) return text;

    const parts = text.split('.');
    if (parts.length === 1 || !parts[parts.length - 1]) {
        return text.substring(0, maxLength - 3) + '...';
    }

    const suffix = parts.pop();
    const prefix = parts.join('.');

    const truncated = prefix.substring(0, maxLength - suffix.length - 3) + '...';
    return `${truncated}.${suffix}`;
};
